import {
	platformService,
	TextButton,
	Tooltip,
	useSearchArray,
} from '@monthio/react-components'
import React, { FunctionComponent, useEffect, useState } from 'react'
import styled from 'styled-components'
import { localOverridesService } from '../localOverridesServices'
export const LocalOverrides: FunctionComponent<{ children?: never }> = () => {
	const [configs, setConfigs] = useState(getOverrides())
	const [search, setSearch] = useState('')
	const filtered = useSearchArray(configs, search, {
		debounced: true,
		debounceDelay: 10,
		searchOptions: { key: '_search' },
	})
	useEffect(() => {
		const subscription = localOverridesService.update.subscribe(() => {
			setConfigs(getOverrides())
		})

		return () => {
			subscription.unsubscribe()
		}
	}, [])
	return (
		<div>
			<span>
				<input
					placeholder="Search"
					onChange={(e) => setSearch(e.target.value)}
				/>
			</span>
			<button onClick={localOverridesService.resetLocalOverrides}>
				reset overrides
			</button>
			<button
				onClick={() => {
					const configs = platformService.getConfigs()
					configs.apps.forEach((app) =>
						localOverridesService.enableOverride(
							app.id as any,
							`http://${location.host}/proxy/${app.url}`,
						),
					)
					configs.clients.forEach((app) =>
						localOverridesService.enableOverride(
							app.id as any,
							`http://${location.host}/proxy/${app.url}`,
						),
					)
				}}
			>
				Override all services for localhost portal
			</button>
			<span>
				{(search?.length > 0 ? filtered : configs)
					.filter((i) => i.active)
					.map((i) => i.component)}
			</span>
		</div>
	)
}

const getOverrides = () => {
	const { apps, clients } = platformService.getConfigs()
	return apps.concat(clients).map((config) => ({
		_search: `${config.id}${config.name}${config.type}`,
		active: config.overrideUrl != null,
		component: (
			<LocalOverride
				key={`${config.id}:${config.overrideUrl ?? config.url}`}
				appId={config.id}
				url={config.url}
				name={config.name}
				type={config.type}
				overrideUrl={config.overrideUrl}
			/>
		),
	}))
}

const LocalOverrideContainer = styled.div`
	display: flex;
	flex-flow: row nowrap;
	align-items: center;
	text-overflow: ellipsis;
	overflow: hidden;
`

const LocalOverride = ({ appId, name, url, overrideUrl, type }: any) => {
	return (
		<LocalOverrideContainer>
			<Tooltip
				placement="left"
				title={
					<div>
						AppId: {appId}
						<br />
						Url: {url}
					</div>
				}
			>
				<p>
					{name} ({type})
				</p>
			</Tooltip>
			Active url {overrideUrl ?? url}
			{overrideUrl != null ? (
				<TextButton
					onClick={() => localOverridesService.disableOverride(appId)}
				>
					Stop
				</TextButton>
			) : null}
		</LocalOverrideContainer>
	)
}
